import { useState, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useFetchWithFilter = () => {
  const location = useLocation();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const resetData = (data = null) => {
    setData(data);
    setError(null);
  }

  useEffect(() => {
    resetData();
  }, [location.search]);

  const getFilters = (includeParams, excludeParams) => {
    const searchParams = new URLSearchParams(window?.location?.search);
    const filteredEntries = excludeParams.length ? [...searchParams.entries()].filter(
      ([key]) => !excludeParams.includes(key)
    ) : searchParams;
    const finalQuery = Object.keys(includeParams).length ? [...filteredEntries, ...Object.entries(includeParams)] : filteredEntries;
    return `${(new URLSearchParams(finalQuery)).toString()}`
  }

  const hasFilterCount = (extraFilter) => {
    const searchParams = new URLSearchParams(window?.location?.search);
    const filteredEntries = [...searchParams.entries()].filter(
      ([key]) => !extraFilter.includes(key)
    );
    return filteredEntries.length;
  }

  const fetchWithFilter = useCallback(async ({
    apiFn,
    onError,
    withConfirmation = false,
    includeParams={}, 
    excludeParams=[], 
    extraFilter=[],
    fetchWithFilterOnly = false
  }) => {

    const fetchWithoutFilter = Boolean(sessionStorage.getItem('fetchWithoutFilter'));

    if(fetchWithFilterOnly && !hasFilterCount(extraFilter)) {
      return null;
    }
    if(withConfirmation && (!hasFilterCount(extraFilter) && !fetchWithoutFilter)) {
      resetData();
      return null;
    }
    const queryParams = getFilters(includeParams, excludeParams);
    setLoading(true);
    setError(null);
    try {
      const res = await apiFn(queryParams);
      setData(res);
      setError(null);
      return res;
    } catch (err) {
      console.error(err);
      setError(err);
      onError?.(err);
      return null;
    } finally {
      sessionStorage.removeItem('fetchWithoutFilter');
      setLoading(false);
    }

  }, []);

  return { ...data, error, loading, fetchWithFilter, resetData };
}

export default useFetchWithFilter;